import { render, staticRenderFns } from "./classificationConfiguration.vue?vue&type=template&id=41071084&scoped=true"
import script from "./classificationConfiguration.vue?vue&type=script&lang=js"
export * from "./classificationConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41071084",
  null
  
)

export default component.exports